// إشعارات محلية على الجوال محسوبة بتوقيت الفرع (لا توقيت الجهاز)، ولا تُبرمَج إطلاقاً
// لليوم الذي ستُطلق فيه إن كان عطلة/نهاية أسبوع — يُمرَّر offToday و offTomorrow من الخادم.
import i18n from "../i18n";
import { isNative } from "./capacitor";

const IDS = { checkin: 4101, checkout: 4102, grace: 4103 };
const MINUTE = 60000;
const DAY = 24 * 60 * MINUTE;

// لحظة مطلقة تساوي وصول ساعة الفرع إلى hh:mm في يوم الإزاحة المطلوب (0=اليوم، 1=غداً).
const branchAt = (hhmm, tzOff, dayOffset = 0) => {
  const [h, m] = (hhmm || "09:00").split(":").map(Number);
  const b = new Date(Date.now() + tzOff * MINUTE); // ساعة الفرع محمولة في حقول UTC
  const wall = Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate(), h, m, 0) + dayOffset * DAY;
  return new Date(wall - tzOff * MINUTE);
};

// اختر اليوم إن لم يفُت موعده ولم يكتمل، وإلا الغد.
const pickDay = (at0, done) => (done || at0.getTime() <= Date.now() + MINUTE ? 1 : 0);
const offFor = (off, day) => (day === 0 ? off.today : off.tomorrow);

const checkinNotif = (branch, tz, checkedIn, off) => {
  const day = pickDay(branchAt(branch.work_start, tz, 0), checkedIn);
  if (offFor(off, day)) return null;
  return {
    id: IDS.checkin,
    title: i18n.t("reminders.checkinTitle"),
    body: i18n.t("reminders.checkinBody", { time: branch.work_start }),
    schedule: { at: branchAt(branch.work_start, tz, day), allowWhileIdle: true },
  };
};

const graceNotif = (branch, tz, checkedIn, off) => {
  const grace = Number(branch.grace_minutes ?? 10);
  if (grace <= 5) return null;
  const at0 = new Date(branchAt(branch.work_start, tz, 0).getTime() + (grace - 5) * MINUTE);
  const day = pickDay(at0, checkedIn);
  if (offFor(off, day)) return null;
  const at = new Date(branchAt(branch.work_start, tz, day).getTime() + (grace - 5) * MINUTE);
  return {
    id: IDS.grace,
    title: i18n.t("reminders.graceTitle"),
    body: i18n.t("reminders.graceBody"),
    schedule: { at, allowWhileIdle: true },
  };
};

// تذكير الانصراف: اليوم فقط، ولمن سجّل حضوراً ولم ينصرف بعد.
const checkoutNotif = (branch, tz) => {
  const at = new Date(branchAt(branch.work_end, tz, 0).getTime() - 10 * MINUTE);
  if (at.getTime() <= Date.now()) return null;
  return {
    id: IDS.checkout,
    title: i18n.t("reminders.checkoutTitle"),
    body: i18n.t("reminders.checkoutBody", { time: branch.work_end }),
    schedule: { at, allowWhileIdle: true },
  };
};

export const scheduleShiftReminders = async (branch, state = {}) => {
  if (!isNative() || !branch?.work_start) return { scheduled: false };
  const { LocalNotifications } = await import("@capacitor/local-notifications");
  const perm = await LocalNotifications.requestPermissions();
  if (perm.display !== "granted") return { scheduled: false, reason: "denied" };
  await LocalNotifications.cancel({ notifications: Object.values(IDS).map((id) => ({ id })) });
  await LocalNotifications.removeAllDeliveredNotifications().catch(() => {});

  const tz = branch.tz_offset_minutes || 0;
  const { checkedIn, checkedOut } = state;
  const off = { today: Boolean(state.offToday), tomorrow: Boolean(state.offTomorrow) };
  const notifications = [];
  const ci = checkinNotif(branch, tz, checkedIn, off);
  if (ci) notifications.push(ci);
  const g = graceNotif(branch, tz, checkedIn, off);
  if (g) notifications.push(g);
  if (checkedIn && !checkedOut) {
    const co = checkoutNotif(branch, tz);
    if (co) notifications.push(co);
  }
  if (notifications.length) await LocalNotifications.schedule({ notifications });
  return { scheduled: notifications.length > 0, count: notifications.length };
};
